import { Controller } from "@hotwired/stimulus"
export default class extends Controller {
    static outlets = [ "popiniframe" ];
    connect() {

    }
    openPopin(event) {
        const embedVideo = event.currentTarget.getAttribute('data-popiniframe-video'),
        title = event.currentTarget.getAttribute('data-popiniframe-title');

        this.popiniframeOutlet.open(embedVideo, title);
    }
}
